import { tenantPath } from "../tenant-paths.ts";
import { suppressSessionRedirect } from "./auth-redirect.ts";

export const signedOutPath = (slug: string): string => `${tenantPath(slug)}?signed_out=1`;

// Deleting the cookie can make an in-flight poll 401; suppress the expiry redirect so it can't
// hijack the navigation and silently re-authenticate.
export const requestLogout = async (): Promise<void> => {
  suppressSessionRedirect();
  const response = await fetch("/auth/logout", { method: "POST", credentials: "include" });
  if (!response.ok) throw new Error("Sign out failed");
};

export const signOutAndLeave = async (slug: string, beforeLeave?: () => void): Promise<void> => {
  await requestLogout().catch(() => undefined);
  beforeLeave?.();
  window.location.assign(signedOutPath(slug));
};
